import { Avatar, Menu, MenuItem } from '@material-ui/core';
import * as React from 'react';

import { inject } from 'mobx-react';
import { IUser } from 'src/Definitions';
import { IStores } from 'src/Stores';
import ChangePasswordDialog from 'src/users/ChangePasswordDialog';
import UserDialog from 'src/users/UserDialog';
import ExpandableListItem from '../ExpandableListItem';

interface IProfileListItemProps {
    currentUser?: IUser;
    expanded: boolean;
    isChangePasswordModalOpen?: boolean;
    isModalOpen?: boolean;
    logout: () => void;
    openChangePasswordDialog?: () => void;
    openDialogWithUser?: (user: IUser) => void;
}

interface IProfileListItemState {
    anchorEl?: HTMLElement;
    exitedMethod?: () => void;
    isMenuOpen: boolean;
}

class ProfileListItem extends React.Component<IProfileListItemProps, IProfileListItemState> {
    public state = {
        anchorEl: undefined,
        exitedMethod: undefined,
        isMenuOpen: false,
    };

    public render() {
        const { currentUser, expanded, isChangePasswordModalOpen, isModalOpen } = this.props;
        const { anchorEl, isMenuOpen } = this.state;
        const changePasswordDialog = isChangePasswordModalOpen && <ChangePasswordDialog />;
        const userDialog = isModalOpen && <UserDialog />;
        return (
            <>
                <ExpandableListItem
                    key={'profile'}
                    expanded={expanded}
                    icon={<Avatar src={currentUser!.profileImageUrl} />}
                    text={currentUser!.name}
                    onClick={this.onClick}
                />
                <Menu
                    anchorEl={anchorEl}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    open={isMenuOpen}
                    getContentAnchorEl={null}
                    onClose={this.closeAndSetExitedMethod()}
                    onExited={this.state.exitedMethod}
                >
                    <MenuItem onClick={this.closeAndSetExitedMethod(this.openChangePassword)}>
                        Change Password
                    </MenuItem>
                    <MenuItem onClick={this.closeAndSetExitedMethod(this.openMyProfile)}>
                        My Profile
                    </MenuItem>
                    <MenuItem onClick={this.closeAndSetExitedMethod(this.logout)}>Logout</MenuItem>
                </Menu>
                {changePasswordDialog}
                {userDialog}
            </>
        );
    }

    private closeAndSetExitedMethod = (method?: () => void) => () => {
        this.setState({ anchorEl: undefined, exitedMethod: method, isMenuOpen: false });
    };

    private openChangePassword = () => {
        this.props.openChangePasswordDialog!();
    };

    private openMyProfile = () => {
        this.props.openDialogWithUser!(this.props.currentUser!);
    };

    private logout = () => {
        this.props.logout();
    };

    private onClick = (event: React.MouseEvent<HTMLElement>) => {
        this.setState({ anchorEl: event.currentTarget, isMenuOpen: true });
    };
}

const InjectedProfileListItem = inject<
    IStores,
    IProfileListItemProps,
    Partial<IProfileListItemProps>,
    any
>((stores: IStores) => ({
    currentUser: stores.global.user,
    isChangePasswordModalOpen: stores.users.isChangePasswordModalOpen,
    isModalOpen: stores.users.isModalOpen,
    openChangePasswordDialog: stores.users.openChangePasswordDialog,
    openDialogWithUser: stores.users.openDialogWithUser,
}))(ProfileListItem);

export default InjectedProfileListItem;
export { IProfileListItemProps };



// WEBPACK FOOTER //
// ./src/common/ProfileListItem/ProfileListItem.tsx